import { StyleConstants } from "Shared/Styles/StyleConstants";
import { makeStyles } from "@fluentui/react-components";
import { themeTokens } from "Core/Theme";

export const useStyles = makeStyles({
    root: {},
    appMenuHeader: {
        display: "inline-block",
        fontFamily:
            "SegoeUI-SemiBold-final,Segoe UI Semibold,SegoeUI-Regular-final,Segoe UI,Segoe UI Web (West European),Segoe,-apple-system,BlinkMacSystemFont",
        paddingLeft: "12px",
        fontSize: "16px",
        lineHeight: `${StyleConstants.appLineHeight}px`,
        letterSpacing: "-0.025em",
        color: "white",
        verticalAlign: "13px",
        minWidth: "85px",
        WebkitFontSmoothing: "antialiased"
    },
    leftIcon: {
        fontSize: "26px",
        color: "white"
    },
    leftIconContainer: {
        minWidth: `${StyleConstants.leftBarWidth}px`,
        marginRight: "10px",
        height: "50px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        backgroundColor: themeTokens.siteHeaderBackgroundColor,
        ":hover": { opacity: 0.5 }
    },
    largeScreenLogoMargin: {
        marginLeft: "15px"
    },
    leftIconContainerInSmallScreen: {
        minWidth: `${StyleConstants.leftBarSmallWidth}px`,
        marginRight: "0px"
    },
    headerConatiner: {
        display: "flex",
        alignItems: "center",
        paddingRight: "10px",
        marginRight: "auto"
    }
});
